import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'dual-choice',
    templateUrl: './dual-choice.component.html',
    styleUrls: ['./dual-choice.component.scss']
})
export class DualChoiceComponent {

    @Input() title: string;
    @Input() resultLinesTitle: string;
    @Input() resultLines: string[] = [];
    @Input() showResultLines: boolean = false;

    @Output() positiveEvent = new EventEmitter;
    @Output() negativeEvent = new EventEmitter;

    choiceLocked = false;

    positiveClick(event: Event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.choiceLocked) {
            return;
        }

        this.choiceLocked = true;
        this.positiveEvent.emit();
    }

    negativeClick(event: Event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (this.choiceLocked) {
            return;
        }

        this.choiceLocked = true;
        this.negativeEvent.emit();
    }
}